import
  React, {
  memo,
  useState,
  useEffect,
  useCallback,
  useRef
} from 'react';

import
  styled
from 'styled-components';

import {
  Colors,
  FontSizes,
} from 'common';

import {
  Button,
  Text,
  TextInput,
  InformationBubble,
} from 'common/components';

import './select.css';

const Container = styled.div`
  position: relative;
  margin: ${props => props.margin || '0 0 10px 0'};
  width: ${props => props.width || '250px'};

  ${props => props.flex && `flex: ${props.flex};`}
  ${props => props.padding && `padding: ${props.padding};`}
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
`;

const Item = styled.div`
  padding: 0 20px;
  width: ${props => props.isMultiSelect ? '90%' : '100%'};
  text-overflow: ellipsis;
  overflow: hidden;
`;

const SearchBoxContainer = styled.div`
  position: absolute;
  top: 40px;
  width: 100%;
  margin: 5px 0;
  z-index: 1000;
  box-shadow: 0 0 6px 0 #A9A9A9;
  border-radius: 5px;
`;

const TrashCanContainer = styled.div`
  cursor: pointer;
  position: relative;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 5px;
`;

const LabelContainer = styled.div`
  display: flex;
  position: relative;
`;

const SelectWrapper = memo(
  ({
    id,
    children,
    placeholder,
    select = '',
    noOptionsText,
    optionsIsLoading,
    loadingText,
    isLoadingIcon = true,
    optionsCustomStyle = {},
    selectCustomStyle = {},
    isMultiSelect,
    isSearchable,
    isClearable,
    trashcanColor = Colors.White,
    displaySelectedInline = false,
    allowOtherAdd = false,
    selectPreContent = '',
    defaultValue = '',
    hasError = false,
    errorMessage = '',
    onAddButtonClick,
    onClearAllClick,
  }) => {

    const stateSelect = useState(select);
    const stateInputValue = useState('');
    const stateInputWidth = useState(2);
    const stateIsShowList = useState(false);
    const stateSelectList = useState(null);
    const stateIsfocus = useState(false);
    const selectRef = useRef(null);
    const inputRef = useRef(null);
    const fakeInputRef = useRef(null);
    const stateCurrentItemIndex = useState(null);
    const listWrapRef = useRef(null);
    const listRef = useRef(null);

    const {
      width,
      selectColor,
      selectBorderRadius
    } = selectCustomStyle;

    const {
      maxHeight,
      optionsBorderColor,
      optionsBorderRadius,
      optionHoverBgColor,
      optionActiveBgColor,
      optionActiveColor
    } = optionsCustomStyle;

    const getIndexof = useCallback((value, string) => {

      const stringToLower = string
        .toString()
        .toLowerCase();

      return value
        .toString()
        .toLowerCase()
        .indexOf(stringToLower);

    }, []);

    useEffect(() => {
      stateSelectList[1](children);
    }, [children]); // eslint-disable-line react-hooks/exhaustive-deps

    const outSideClick = useCallback(e => {

      if(!listWrapRef.current) {
        return;
      }

      if (selectRef.current && !selectRef.current.contains(e.target)) {

        stateIsShowList[1](false);
        stateIsfocus[1](false);
        stateInputValue[1]('');
      }

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

      document.addEventListener(
        'click',
        outSideClick
      );

      return () => {

        document.removeEventListener(
          'click',
          outSideClick
        );
      };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      stateSelect[1](select);
    }, [select]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {

      stateInputWidth[1](fakeInputRef.current.clientWidth
        ? fakeInputRef.current.clientWidth + 16
        : 2
      );

      if (stateInputValue[0]) {

        if (stateSelectList[0]) {

          const filterArray = [];

          for (let i = 0; i < children.length; i++) {

              if (getIndexof(children[i].props.display, stateInputValue[0]) >= 0) {

                filterArray.push(children[i]);
              }
          }

          filterArray.sort((prev, cur) => {

            return getIndexof(prev.props.display, stateInputValue[0]) - getIndexof(cur.props.display, stateInputValue[0]);
          });

          stateSelectList[1](filterArray);
        }

        stateIsShowList[1](true);

      } else {

        stateSelectList[1](children);
      }

    }, [stateInputValue[0], children]); // eslint-disable-line react-hooks/exhaustive-deps

    let multiSelectHtml = [];
    let displayInlineText = [];
    let listHtml;

    if (isMultiSelect && !displaySelectedInline) {

      multiSelectHtml = children
        .filter(child => child.props.checked)
        .map((child, index) => {

          return (

            <div
              key={`multi-${index}`}
              className={'multiSelectItem'}>

              <span>{child.props.display}</span>

              <span className={'multiSelectItemRemove'} onClick={() => {

                child.props.onChange({ target: { checked: false }}, child.props);

              }}>x</span>

            </div>
          );
        });
    }

    if (displaySelectedInline) {

      displayInlineText = children
        .filter(child => child.props.checked)
        .map((child, index) => {
          return child.props.display;
        });
    }

    if (optionsIsLoading) {

      listHtml = (
        <li className={'loadingItem'}>
          {isLoadingIcon ? (
            <div className={'loadingIcon'}>
              <svg width="14px" height="14px" viewBox="0 0 1024 1024">
                <path
                  d="M511.882596 287.998081h-0.361244a31.998984 31.998984 0 0 1-31.659415-31.977309v-0.361244c0-0.104761 0.115598-11.722364 0.115598-63.658399V96.000564a31.998984 31.998984 0 1 1 64.001581 0V192.001129c0 52.586273-0.111986 63.88237-0.119211 64.337537a32.002596 32.002596 0 0 1-31.977309 31.659415zM511.998194 959.99842a31.998984 31.998984 0 0 1-31.998984-31.998984v-96.379871c0-51.610915-0.111986-63.174332-0.115598-63.286318s0-0.242033 0-0.361243a31.998984 31.998984 0 0 1 63.997968-0.314283c0 0.455167 0.11921 11.711527 0.11921 64.034093v96.307622a31.998984 31.998984 0 0 1-32.002596 31.998984zM330.899406 363.021212a31.897836 31.897836 0 0 1-22.866739-9.612699c-0.075861-0.075861-8.207461-8.370021-44.931515-45.094076L195.198137 240.429485a31.998984 31.998984 0 0 1 45.256635-45.253022L308.336112 263.057803c37.182834 37.182834 45.090463 45.253022 45.41197 45.578141A31.998984 31.998984 0 0 1 330.899406 363.021212zM806.137421 838.11473a31.901448 31.901448 0 0 1-22.628318-9.374279L715.624151 760.859111c-36.724054-36.724054-45.018214-44.859267-45.097687-44.93874a31.998984 31.998984 0 0 1 44.77618-45.729864c0.32512 0.317895 8.395308 8.229136 45.578142 45.411969l67.88134 67.88134a31.998984 31.998984 0 0 1-22.624705 54.630914zM224.000113 838.11473a31.901448 31.901448 0 0 0 22.628317-9.374279l67.88134-67.88134c36.724054-36.724054 45.021826-44.859267 45.097688-44.93874a31.998984 31.998984 0 0 0-44.776181-45.729864c-0.32512 0.317895-8.395308 8.229136-45.578142 45.411969l-67.88134 67.884953a31.998984 31.998984 0 0 0 22.628318 54.627301zM255.948523 544.058589h-0.361244c-0.104761 0-11.722364-0.115598-63.658399-0.115598H95.942765a31.998984 31.998984 0 1 1 0-64.00158h95.996952c52.586273 0 63.88237 0.111986 64.337538 0.11921a31.998984 31.998984 0 0 1 31.659414 31.97731v0.361244a32.002596 32.002596 0 0 1-31.988146 31.659414zM767.939492 544.058589a32.002596 32.002596 0 0 1-31.995372-31.666639v-0.361244a31.998984 31.998984 0 0 1 31.659415-31.970085c0.455167 0 11.754876-0.11921 64.34115-0.11921h96.000564a31.998984 31.998984 0 0 1 0 64.00158H831.944685c-51.936034 0-63.553638 0.111986-63.665624 0.115598h-0.335957zM692.999446 363.0176a31.998984 31.998984 0 0 1-22.863126-54.381656c0.317895-0.32512 8.229136-8.395308 45.41197-45.578141l67.88134-67.884953A31.998984 31.998984 0 1 1 828.693489 240.429485l-67.892177 67.88134c-31.020013 31.023625-41.644196 41.759794-44.241539 44.393262l-0.697201 0.722488a31.908673 31.908673 0 0 1-22.863126 9.591025z"
                  p-id="818"
                ></path>
              </svg>
            </div>
          ) : (
            ''
          )}
          {loadingText ? loadingText : 'Loading...'}
        </li>
      );

    } else if (stateSelectList[0] && stateSelectList[0].length) {

      listHtml = stateSelectList[0].map((child, index) => {

        return (
          <li
            style={{
              backgroundColor:
                stateSelect[0] === child.props.value
                  ? optionActiveBgColor
                    ? optionActiveBgColor
                    : '#E2E2E2'
                  : stateCurrentItemIndex[0] === index
                    ? optionHoverBgColor
                      ? optionHoverBgColor
                      : '#E2E2E2'
                    : '',
              color: child.props.disabled ? '#d9d9d9' : stateSelect[0] === child.props.value ? (optionActiveColor ? optionActiveColor : '##1F1F1F') : child.props.color ? child.props.color : stateCurrentItemIndex[0] === index ? '#1F1F1F' : '',
              cursor: child.props.disabled ? 'not-allowed' : '',
            }}
            ref={ref => {
              stateCurrentItemIndex[0] === index && (listRef.current = ref);
            }}
            className={'selectListItem'}
            key={child.key}
            onClick={() => {

              if (child.props.disabled) return;

              if (isMultiSelect) {

                child.props.onChange({ target: { checked: !child.props.checked }}, child.props);
                return;
              }

              stateIsShowList[1](false);
              stateInputValue[1]('');
              stateSelect[1](child.props.display);
            }}
            onMouseEnter={() => stateCurrentItemIndex[1](index)}
          >
            { isMultiSelect &&

              <input
                type={'checkbox'}
                className={'checkbox'}
                checked={child.props.checked || false}
                onChange={e => { 
                  
                  child.props.onChange(e, child.props);
                }}
              />
            }

            {child}

            { !!child.props.info &&
                      
              <InformationBubble
                text={child.props.info}
              />
            }

          </li>
        );
      });

    } else if (isMultiSelect && allowOtherAdd) {

      listHtml = (
        <div style={{ padding: '0 5px' }}>

          <Button
            text={'ADD'}
            width={'100%'}
            onClick={() => {

              const target = {
                target: {
                  checked: true
                }
              };

              const val = {
                display: stateInputValue[0],
                value: stateInputValue[0],
                checked: true,
                shouldAdd: true,
              };

              onAddButtonClick(target, val);
            }}
          />
        </div>
      );
    }
    else {

      listHtml = <li className={'noItem'}>{noOptionsText ? noOptionsText : 'No options'}</li>;
    }

    return (
      <div className={'selectWrapper'} ref={selectRef} style={{ width }}>

        { isMultiSelect &&

          <div>
            {multiSelectHtml}
          </div>
        }

        <div className={'inputTrashWrapper'}>
          <div
            className={`${'inputWrapper'}`}
            style={{
              paddingRight: stateInputValue[0] && isClearable ? '60px' : '',
              color: selectColor,
              borderRadius: selectBorderRadius,
              border: hasError ? '1px solid #D9072D' : '',
            }}
            onClick={() => {
              stateIsfocus[1](true);
              inputRef.current.focus();
              stateInputValue[1]('');
              stateIsShowList[1](!stateIsShowList[0]);
            }}
          >
            <input
              readOnly={true}
              className={'myInput'}
              type="text"
              value={stateInputValue[0]}
              ref={inputRef}
              style={{ width: `${stateInputWidth[0]}px`, display: 'none' }}
              onChange={e => stateInputValue[1](e.target.value)}
              onFocus={() => stateIsfocus[1](true)}
            />
            <div ref={fakeInputRef} className={'fakeInput'}>
              {stateInputValue[0]}
            </div>
            {(!stateInputValue[0] && stateSelect[0]) || defaultValue || displayInlineText.length ? (
              <div className={'selectValue'}>
                <span className={'selectValueText'}>
                  {selectPreContent}
                  {stateSelect[0] || defaultValue || displayInlineText.join('; ')}
                </span>
              </div>
            ) : (
              ''
            )}
            {!stateInputValue[0] && !stateSelect[0] && !defaultValue && !displayInlineText.length ? <div className={'placeholder'}>{placeholder ? placeholder : 'Select...'}</div> : ''}
            {isClearable ? (
              <svg
                width="16px"
                height="16px"
                className={'clearAllIcon'}
                onClick={e => {
                  e.stopPropagation();
                  inputRef.current.focus();
                  stateInputValue[1]('');
                  !isSearchable && stateSelect[1]('');
                }}
                style={{ visibility: (isSearchable ? stateInputValue[0] : stateSelect[0]) ? '' : 'hidden' }}
                viewBox="0 0 1024 1024"
              >
                <path
                  d="M685.4 354.8c0-4.4-3.6-8-8-8l-66 0.3L512 465.6l-99.3-118.4-66.1-0.3c-4.4 0-8 3.5-8 8 0 1.9 0.7 3.7 1.9 5.2l130.1 155L340.5 670c-1.2 1.5-1.9 3.3-1.9 5.2 0 4.4 3.6 8 8 8l66.1-0.3L512 564.4l99.3 118.4 66 0.3c4.4 0 8-3.5 8-8 0-1.9-0.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z"
                  p-id="1052"
                ></path>
                <path
                  d="M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                  p-id="1053"
                ></path>
              </svg>
            ) : (
              ''
            )}
            <svg
              tabIndex={0}
              width="16px"
              height="16px"
              className={`${'dropdownIcon'} ${stateIsShowList[0] ? 'active' : ''}`}
              onClick={() => {}}
              onKeyUp={e => (e.key === 'Enter' || e.keyCode === 13) && e.currentTarget.parentElement.click()}
              viewBox="0 0 1024 1024">

              <path
                d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3 0.1-12.7-6.4-12.7z"
                p-id="935"
              ></path>
            </svg>
          </div>

          {!!displayInlineText.length && 
          
            <TrashCanContainer
              className={'select-trash-can'}
              onClick={onClearAllClick}>

              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 12.488 16.056">
                <path d="M8.392,18.772a1.789,1.789,0,0,0,1.784,1.784h7.136A1.789,1.789,0,0,0,19.1,18.772V8.068H8.392Zm11.6-13.38H16.866L15.974,4.5h-4.46l-.892.892H7.5V7.176H19.988Z" transform="translate(-7.5 -4.5)" fill={trashcanColor || Colors.White}/>
              </svg>

            </TrashCanContainer>
          }
        </div>

        <div
          className={'selectListWrapper'}
          ref={listWrapRef}
          style={{
            display: stateIsShowList[0] ? 'block' : 'none',
            maxHeight,
            borderColor: optionsBorderColor ? optionsBorderColor : '',
            borderRadius: optionsBorderRadius ? optionsBorderRadius : '',
            overflowX: 'hidden',
            top: (isMultiSelect || isSearchable) ? '80px' : '40px',
          }}
        >
          
          <ul className={'selectList'}>{listHtml}</ul>

        </div>

        { (isMultiSelect || isSearchable) && stateIsShowList[0] &&
          
          <SearchBoxContainer>

            <TextInput
              borderRadius={'5px 5px 0 0'}
              width={'100%'}
              margin={'0'}
              placeholder={'Search...'}
              onChange={val => stateInputValue[1](val)}
              autofocus={true}
            />

          </SearchBoxContainer>
        }

        { hasError &&

          <div
            style={{
              textAlign: 'right',
              color: '#D9072D',
              fontSize: '11.2px',
              lineHeight: '1.5',
              paddingTop: '5px',
              paddingRight: '3px',
            }}
          >{errorMessage}</div>
        }

        {/* This is a hack, when id is passed, add a hidden div that can be triggered to clear the select */}
        { !!id &&

          <div
            style={{ display: 'none' }}
            id={`${id}-secretclear`}
            onClick={e => {
              e.stopPropagation();
              stateInputValue[1]('');
              stateSelect[1]('');
            }}
          />
        }

      </div>
    );
  },
);

export class Select extends React.Component {

  state = {
    options: this.props.options || [],
    showInformation: false,
  };

  maxItems = this.props.maxItems || 9999;

  onShowItemInformation = () => {

    this.setState({
      showInformation: true
    });
  };

  onHideItemInformation = () => {

    this.setState({
      showInformation: false
    });
  };
  
  onChange = (e, item) => {

    if (this.props.isMultiSelect) {
      return;
    }

    typeof this.props.onChange === 'function' && this.props.onChange(item, this.props.onChangeArgs);
  };

  onMultiSelectChange = (e, item) => {

    const isChecked = e.target.checked;

    if (isChecked && this.maxItems !== 9999) {

      let checkedList = this.state.options.filter(function(obj) {
        return obj.checked;
      });

      if (checkedList.length >= this.maxItems) {
        return;
      }
    }

    let list = this.state.options.map(multiItem => {

      if (multiItem.value === item.value) {
        multiItem.checked = isChecked;
      }

      return multiItem;
    });

    if (item.shouldAdd) {

      item.shouldAdd = false;
      list.push(item);
    }

    let filteredList = list.filter(function(obj) {
      return obj.checked;
    });

    this.setState({
      options: list
    });

    typeof this.props.onChange === 'function' && this.props.onChange(filteredList, this.props.onChangeArgs);
  };

  onClearAllClick = () => {

    let list = this.state.options.map(multiItem => {

      multiItem.checked = false;
      return multiItem;
    });

    this.setState({
      options: list
    });

    typeof this.props.onChange === 'function' && this.props.onChange([], this.props.onChangeArgs);
  };

  componentDidUpdate(prevProps) {

    if (prevProps.options !== this.props.options || prevProps.defaultOptions !== this.props.defaultOptions) {

      let list = this.props.options;

      if (Array.isArray(this.props.defaultOptions) && this.props.defaultOptions.length) {

        list = this.props.options.map(multiItem => {

          for (let i = 0; i < this.props.defaultOptions.length; i++) {
            
            if (multiItem.value === (this.props.defaultOptions[i].value || this.props.defaultOptions[i])) {

              multiItem.checked = true;
              multiItem.id = this.props.defaultOptions[i].id;
              break;
            }
          }
    
          return multiItem;
        });

        for (let i = 0; i < this.props.defaultOptions.length; i++) {
            
          if (this.props.defaultOptions[i].isOtherOption) {

            this.props.defaultOptions[i].checked = true;
            list.push(this.props.defaultOptions[i]);
          }
        }
      }

      this.setState({
        options: list,
      });
    }
  }

  render () {

    let optionList = this.state.options || [];

    let checkedOptions = optionList.filter(c => c.checked);
    let unCheckedOptions = optionList.filter(c => !c.checked);

    optionList = [...checkedOptions, ...unCheckedOptions];

    let defaultSelected;

    for (let i = 0; i < optionList.length; i++) {

      if (optionList[i].value === this.props.defaultValue) {

        defaultSelected = optionList[i].display;
        break;
      }
    }

    return (

      <Container
        id={this.props.id}
        flex={this.props.flex}
        margin={this.props.margin}
        padding={this.props.padding}
        width={this.props.width}
        maxWidth={this.props.maxWidth}>

        { this.props.label &&
        
          <LabelContainer>

            <Text
              color={this.props.labelColor || Colors.Black}
              fontSize={FontSizes.Small}
              padding={'0 0 10px 0'}
              fontWeight={'bold'}>

                {this.props.label}
            </Text>

            <InformationBubble
              id={this.props.id}
            />
            
          </LabelContainer>
        }

        <SelectWrapper
          {...this.props}
          defaultValue={defaultSelected}
          onAddButtonClick={this.onMultiSelectChange}
          onClearAllClick={this.onClearAllClick}>

          { optionList.map((item, i) => {

              return (

                <Item
                  key={i}
                  id={item.id}
                  value={item.value}
                  display={item.display}
                  info={item.info}
                  disabled={item.isDisabled}
                  checked={item.checked}
                  onClick={e => this.onChange(e, item)}
                  onChange={e => this.onMultiSelectChange(e, item)}
                  isMultiSelect={this.props.isMultiSelect}>
                  
                    {item.display}
                </Item>
              );
            })
          }
        </SelectWrapper>

      </Container>
    );
  }
};